import React from "react";
import { InformationBoxesProps } from "./types";
import styles from "./styles.module.scss";

const InformationBoxes = ({ children }: InformationBoxesProps) => {
  return <div className={styles["information-boxes"]}>{children}</div>;
};

export default InformationBoxes;
